<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QFbhAA/d2d_images/cover.jpg" alt="This image is the cover for the book La città del peccato"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La città del peccato
      </h1>
      <p class="bookDescription body article font2">
        <p>Mike è un uomo enigmatico che arriva a Las Vegas per godersi le sue sole 48 ore di ferie dell'anno. La fortuna sarà dalla sua parte e gli permetterà di vincere un grosso premio a una slot machine dell'hotel Bellagio e di incrociare la strada di Cristine, una donna che gli farà provare nuovi sentimenti. Riuscirà Mike a conquistare Cristine dopo che lei ha scoperto il grande segreto che lui nasconde sulla sua vera identità?<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stefania Gil, Stefano Vazzola
      </h2>
      
      <p class="authorDescription body article">Nacque a Caracas, Venezuela. Studiò Graphic Design e, dopo molti passi falsi, scoprì che la sua vera vocazione era scrivere. È un'autrice auto-pubblicata di romanzi rosa e di romanzi rosa paranormali. Adora leggere, e tutto ciò che è mistico e paranormale attira subito la sua attenzione. È immensamente curiosa di sapere cosa c'è al di là di ciò che si può vedere a prima vista, e forse è questo che l'ha portata a frequentare corsi di tarocchi, Wicca, Alta Magia e Reiki. Attualmente risiede nella città di Malaga con suo marito e una figlia piccola. E dal suo studio vista mare continua a scrivere per compiacere i suoi lettori.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?266f00ed